import { CollisionFilterExtension as CollisionFilterExtension_ } from "@deck.gl/extensions";

export default class CollisionFilterExtension extends CollisionFilterExtension_ {
    initializeState(this, context, extension) {
        super.initializeState(context, extension);
        const eff = context.deck.effectManager.getEffects().find(e => e.id === 'collision-filter-effect');
        if (eff) {
            // console.log('CollisionFilterExtensionFix found effect:', eff, context.deck.effectManager._defaultEffects);
            eff.preRender = preRender.bind(eff);
        }
        else {
            // console.warn('CollisionFilterExtensionFix could not find collision-filter-effect in effect manager:', context.deck.effectManager.getEffects(), context);
        }
    }
}

const DOWNSCALE = 2;
function preRender({ effects: allEffects, layers, layerFilter, viewports, onViewportActive, views, isPicking, preRenderStats = {} }) {
    const { device } = this.context;
    if (isPicking) return;
    const collisionLayers = layers.filter(({ props: { visible, collisionEnabled } }) => visible && collisionEnabled);
    if (collisionLayers.length === 0) {
        this.channels = {};
        return;
    }
    const effects = allEffects?.filter((e) => e.useInPicking && preRenderStats[e.id]);
    const maskEffectRendered = preRenderStats["mask-effect"]?.didRender;
    const channels = this._groupByCollisionGroup(device, collisionLayers);
    const viewport = viewports[0];
    const viewportChanged = !this.lastViewport || !this.lastViewport.equals(viewport) || maskEffectRendered;
    for (const collisionGroup in channels) {
        const collisionFBO = this.collisionFBOs[collisionGroup];
        const renderInfo = channels[collisionGroup];
        // const [width, height] = device.canvasContext.getPixelSize();
        const width = device.canvasContext.drawingBufferWidth;
        const height = device.canvasContext.drawingBufferHeight;
        // const width = device.canvasContext.cssWidth * device.canvasContext.devicePixelRatio;
        // const height = device.canvasContext.cssHeight * device.canvasContext.devicePixelRatio;
        // console.log('collisionFBO resize', collisionGroup, width, height, w, h, device.canvasContext.devicePixelRatio, width / DOWNSCALE, height / DOWNSCALE);
        collisionFBO.resize({
            width: width / DOWNSCALE,
            height: height / DOWNSCALE
        });
        this._render(renderInfo, {
            effects,
            layerFilter,
            onViewportActive,
            views,
            viewport,
            viewportChanged
        });
    }
    // debugFBO(this.collisionFBOs[Object.keys(channels)[0]], {minimap: true});
}